import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LoanRemarksCreateModalSF from '../../../components/superUser/loan/util/LoanRemarksCreateModalSF'
import LoanRemarksUpdateModalSF from '../../../components/superUser/loan/util/LoanRemarksUpdateModalSF'
import './ReportCardPage.css'

const MonitoringRemarksPageUI = ({ context, errorList,
  loan, onRefreshClick, createMode, onCancelRemarksClick, onCreateRemarksClick, objectCode, objectId, monitoringRemarksList,
  updateRemarksMode, onUpdateRemarksClick, selectedRemarks, selectedRemarksId
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_repc'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='monitoring'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <IconButtonUI icon='icon-plus' onClick={onCreateRemarksClick} />
              <span className='g_m_left_100 g_large'><b>Monitoring remarks</b></span>
            </span>
          }
          right={<span />}
        />

        <MonitoringRemarksUI
          loan={loan}
          context={context}
          createMode={createMode}
          onCreateRemarksClick={onCreateRemarksClick}
          onCancelRemarksClick={onCancelRemarksClick}
          onRefreshClick={onRefreshClick}
          objectCode={objectCode}
          objectId={objectId}
          monitoringRemarksList={monitoringRemarksList}
          updateRemarksMode={updateRemarksMode}
          onUpdateRemarksClick={onUpdateRemarksClick}
          selectedRemarks={selectedRemarks}
          selectedRemarksId={selectedRemarksId}
        />

      </div>
    }
  </SuperUserLoanPageSF>

const MonitoringRemarksUI = ({ context, loan, onRefreshClick,
  createMode, onCancelRemarksClick, onCreateRemarksClick, objectCode, objectId, monitoringRemarksList,
  updateRemarksMode, onUpdateRemarksClick, selectedRemarks, selectedRemarksId
}) =>
  <CardUI>
    <table className='g_full_width g_m_top_20'>
      <thead>
        <tr>
          <th className='g_p_right_100'>Date</th>
          <th className='g_p_left_100'>Remarks</th>
          <th className='g_p_left_100'>Actions</th>
        </tr>
      </thead>
      <tbody>
        {monitoringRemarksList && monitoringRemarksList.length > 0 && (
          monitoringRemarksList.map((remarks, i) => (
            <tr key={i}>
              <td className='g_p_right_100' style={{ whiteSpace: 'nowrap', verticalAlign: 'top' }} >{remarks.remarksDateF}</td>
              <td className='g_p_left_100'>{remarks.remarks}</td>
              <td className='g_p_left_100'>
                <span className="icon icon-pencil g_cursor_pointer g_muted" onClick={onUpdateRemarksClick}
                  data-object-id={remarks.objectId} data-date={remarks.remarksDateF}
                  data-remarks={remarks.remarks} data-remarks-id={remarks.remarksId} style={{ verticalAlign: 'top' }}></span>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>

    <LoanRemarksCreateModalSF
      context={context} loan={loan}
      objectCode={objectCode} objectId={objectId}
      updateMode={createMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick}
    />

    <LoanRemarksUpdateModalSF
      context={context} loan={loan}
      selectedRemarks={selectedRemarks} selectedRemarksId={selectedRemarksId}
      updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick}
    />
  </CardUI>

export default MonitoringRemarksPageUI
